export default __webpack_public_path__ + "static/media/tshirt.24797141.jpg";